import Network from "../../../services/Network";
import { FETCH_PROEPRTIES } from "../../../utils/endpoints";
import { path, isEmptyList } from "../../../utils";

export const fetchProperties = (resolve, reject) => Network.GET(FETCH_PROEPRTIES, null, null,
    response => resolve(path(response, 'data', []).map(property => ({
        name: property.property_name,
        status: property.current_funnel_stages,
        image: !isEmptyList(property.image_url) ? property.image_url[0] : '',
        property_unique_id: property.property_unique_id,
        lead_data:property.lead_data
    }))),
    reject
);

const sample = [
    { image: 'https://static.toiimg.com/thumb/72975551.cms?width=680&height=512&imgsize=881753', name: 'Hotel City View' },
    { name: 'Hotel Pyramid', status: 'Setup and Go Live' },
    { image: 'https://static.toiimg.com/thumb/72975551.cms?width=680&height=512&imgsize=881753', name: 'Hotel City View' },
];